/**
 * Average Cost Over Retail Exception Config
 *
 * Covers: ex-inv-ls-avg-cost-over-retail
 *
 * Active inventory products where the average cost at any outlet
 * exceeds the ex-tax retail price.
 */
import { buildProductExceptionConfig } from '../shared/productExceptionColumns'

export const avgCostOverRetailConfig = buildProductExceptionConfig({
  codes: ['ex-inv-ls-avg-cost-over-retail'],
  primaryErrorCode: 'avg_cost_over_retail',
})
